"use client";

import * as React from "react";

import { CopyButton } from "./copy-button";

/**
 * The copy control on a `copyable` code block. Copies the text the block shows,
 * read from the DOM at click time, so it matches whatever children rendered.
 */
export function CodeCopyButton({ testId = "code-copy-button" }: { testId?: string }) {
  const buttonRef = React.useRef<HTMLButtonElement>(null);
  return (
    <CopyButton
      ref={buttonRef}
      size="icon"
      label="Copy code"
      value={() => buttonRef.current?.closest("[data-code-block]")?.querySelector("code")?.textContent ?? ""}
      className="absolute right-1 top-1"
      data-testid={testId}
    />
  );
}
